/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banner_NudgeInputs */



/**
* | output |
* | --- |
* | "No banner yet — shared links show the default card." |
*
* @param {Banner_NudgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const banner_nudge = /** @type {((inputs?: Banner_NudgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banner_NudgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de bannière — les liens partagés affichent la carte par défaut.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay pancarta: los enlaces compartidos muestran la tarjeta predeterminada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda sem banner — os links compartilhados mostram o cartão padrão.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuno striscione — i link condivisi mostrano la scheda predefinita.")
	return /** @type {LocalizedString} */ ("No banner yet — shared links show the default card.")
});